import styled from 'styled-components'

export const Container = styled.div`
  h2 {
    color: var(--text-tertiary);
    font-size: var(--font-size-md);
    font-weight: 600;
    margin: 31px 0;
  }
`

export const BoxBrand = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ isButton }) =>
    isButton ? 'transparent' : 'var(--background)'};
  border: ${({ isButton }) =>
    isButton ? '0px' : '1px solid var(--border-color-table)'};
  box-sizing: border-box;
  border-radius: 13px;
  padding: 24px;
  cursor: ${({ isButton }) => (isButton ? 'pointer' : 'normal')};
  max-width: 189px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h3,
  h4 {
    margin-top: 14px;
    margin-bottom: 0;
    text-align: center;
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
    font-weight: bold;
  }

  h4 {
    font-weight: normal;
  }
`
